// @flow

import { useLocation } from 'react-router-dom';
import { Text, View } from 'reshaped';

import { selectCartTotal } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { useCurrency } from 'src/hooks/useCurrency';

export function DiscountLine(): React.MixedElement | null {
  const { __, formatPrice } = useTranslator();

  const total = useAppSelector(selectCartTotal);

  const location = useLocation();
  const checkoutPage = location.pathname.includes('checkout');

  const currency = useCurrency();

  const discounts = (total.discounts || []).reduce((acc, discount) => {
    return acc + discount.amount;
  }, 0);

  // The discount is a negative sum
  if (!discounts || discounts > 0) return null;

  return (
    <View direction="row" justify="space-between">
      <Text as="p" variant="body-3" weight={checkoutPage ? 'bold' : undefined}>
        {__('Discounts')}
      </Text>

      <Text as="p" variant="body-3" weight={checkoutPage ? 'bold' : undefined}>
        {formatPrice(discounts, currency)}
      </Text>
    </View>
  );
}
